import { render, staticRenderFns } from "./tourCard.vue?vue&type=template&id=23df603d&scoped=true&"
import script from "./tourCard.vue?vue&type=script&lang=js&"
export * from "./tourCard.vue?vue&type=script&lang=js&"
import style0 from "./tourCard.vue?vue&type=style&index=0&id=23df603d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df603d",
  null
  
)

export default component.exports